import clsx from 'clsx'
import classes from '../Card.module.scss'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react';
import { AudioComponentControl } from '@educaplay/core/components/AudioComponentControl';

export function CardAudio({ audioSrc, autoplay }) {
    const [playing, setPlaying] = useState(false);

    useEffect(() => {
      if(!autoplay) return;
  
      const timer = setTimeout(() => {
          setPlaying(true);
      }, 800)
  
      return () => {
        clearTimeout(timer);
      }
    }, [autoplay])

    return (
      <div className={clsx(classes.card__content, classes["card--sound"])}>
        <AudioComponentControl source={audioSrc} autoplay={playing} big={true} className={classes.audioComponent} />
      </div>
    )
}

CardAudio.propTypes = {
    text: PropTypes.string.isRequired,
    audioSrc: PropTypes.string.isRequired
}